import { useQuery } from "react-query";
import { locationMenuService } from "../services";
import { FOUNTAIN_DRINK, LOCATION_MENU_SERVICE } from "../constants";
import axiosNoInterceptor from "../services/axiosNoInterceptor";

interface IQueryParams {
  location_id: string;
  category_id: string;
  item_id: string;
  customer_id?: number;
  visitor_id?: string;
}

const getItem = async ({
  location_id,
  category_id,
  item_id,
  customer_id,
  visitor_id,
}: IQueryParams) => {
  try{
    const params: Record<string, string | number> = {
      location_id,
      category_id,
      item_id,
    };
    if (customer_id != null) {
      params.customer_id = customer_id;
    }
    if (visitor_id) {
      params.visitor_id = visitor_id;
    }
    const response = await axiosNoInterceptor.get(`${LOCATION_MENU_SERVICE}/getLocationMenuItem`, {
      params,
    })
    const isItemFountainDrink = (item) => {
      return item.name.toLowerCase() === FOUNTAIN_DRINK.toLowerCase();
    }
    const category = response?.data?.data?.categories[0];
    const item = response?.data?.data?.categories[0]?.items[0];
    item.basePrice = category?.base
    const itemModifierGroups = !isItemFountainDrink(item) ? item.items_required_modifier_groups.map(
      (group) => ({
        ...group,
        required_modifiers_groups_modifiers:
          group.required_modifiers_groups_modifiers.sort(
            (a, b) => Number(b.in_item) - Number(a.in_item)
          ),
      })
    )
    :
    item.items_required_modifier_groups
    ;
    return {
      ...item,
      itemModifierGroups,
    };
  }catch(error){
    console.error('Failed to fetch item:', error);
    throw error; 
  }
};

export default function useItem(queryParams: IQueryParams) {
  
  const isEnabled = !(queryParams.item_id === undefined || queryParams.item_id === null || !queryParams.location_id)
  return useQuery<any>(
    ["item", queryParams.item_id, queryParams.customer_id, queryParams.visitor_id],
    () => getItem(queryParams),
    {
      enabled: isEnabled
    }
  );
}
